import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { ReactComponent as IconDoodle } from '../../images/illustrated/doodle.svg';
import { colors } from '../../styles/constants';
import AnnimatedCards, { AnimatedCardsProps } from '../AnnimatedCards';
import { P0 } from '../Typographies/Paragraph';
import { H2 } from '../Typographies/Title';

const Container = styled.div`
  ${tw`my-big text-center`}
`;

const Icon = styled(IconDoodle)`
  transform: translateX(-16px) translateY(-5px);
`;

const P = styled(P0)`
  ${tw`text-primary400 my-medium2 md:mt-0 md:mb-huge`}
`;

const CustomH2 = styled(H2)`
  .highlighted {
    color: ${colors['primary-400']};
  }
`;

export type CompaniesProps = {
  stopAnimatedCards: boolean;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  images: AnimatedCardsProps['images'];
  testid?: string;
};

const Companies = ({
  images,
  stopAnimatedCards,
  subtitle,
  testid,
  title,
}: CompaniesProps) => {
  return (
    <Container data-testid={testid}>
      <CustomH2>
        {title} <Icon />
      </CustomH2>

      <P>{subtitle}</P>

      <AnnimatedCards
        durationInMS={40500}
        images={images}
        stop={stopAnimatedCards}
      />
    </Container>
  );
};

export default Companies;
